import { html as m, slotted as o } from "@microsoft/fast-element";
import { NavItem as e } from "./nav-item/index.js";
const l = m`
  <div class="control" part="control">
    <div class="nav-items" @toggle-nav-item="${(t, s) => t.toggleNavItems(s)}">
      <slot
        ${o({
  property: "navItems",
  filter: (t) => t instanceof e
})}
      ></slot>
    </div>
    <div class="bottom-nav-items">
      <slot
        name="bottom"
        ${o({
  property: "bottomNavItems",
  filter: (t) => t instanceof e
})}
      ></slot>
    </div>
  </div>
`;
export {
  l as sidebarTemplate
};
